import { CommonModule } from "@angular/common";
import { Component, OnInit, AfterViewInit, ViewChild, HostListener } from '@angular/core';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { UtilityService } from 'src/app/services/utility.service';
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { NgForm } from "@angular/forms";
import { DrupalRESTService } from "src/app/services/drupal-rest.service";
import { ActivatedRoute, Event, Params, Router } from "@angular/router";
import { saveAs } from 'file-saver';
import moment from "moment";
import { ViewTableComponent } from "../../base/view-table/view-table.component";
import { HttpParameter } from 'src/app/types/http-parameter';
import { StudentDashboardWrapperComponent } from "../../student/student-dashboard-wrapper/student-dashboard-wrapper.component";
import { MatDialog } from '@angular/material/dialog';
import { BookFromInquiryReportComponent } from '../../inquiryReport/book-from-inquiry-report/book-from-inquiry-report.component';
import { DialogService } from 'src/app/services/dialog.service';
import { EntityRESTService } from 'src/app/services/entity-rest.service';
import { FieldsService } from 'src/app/services/fields.service';
import { TaxonomyService } from 'src/app/services/taxonomy.service';
import { AuthRESTService } from 'src/app/services/auth-rest.service';
import { AuthService } from 'src/app/services/auth.service';
import { MenuRESTService } from 'src/app/services/menu-rest.service';
import { FormBuilder } from '@angular/forms';
import { RouteEventsService } from 'src/app/route-events.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { Renderer2, ElementRef, ChangeDetectorRef } from '@angular/core';
import { ConfigPagesService } from 'src/app/services/config-pages.service';
import { PackagesService } from 'src/app/services/packages.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserService } from 'src/app/services/user.service';
import { DomSanitizer } from '@angular/platform-browser';
import { RefreshService } from 'src/app/services/refresh.service';
import { StudioConfigService } from "src/app/services/studio-config.service";
import { ComponentRefreshService } from 'src/app/services/component-refresh.service';
import { TranslateService } from "@ngx-translate/core";
import { PrintService } from 'src/app/services/print.service';
import { LoggerService } from '../../../services/logger.service';

@Component({
  selector: 'app-students-list',
  templateUrl: './inquiry-view.component.html',
  styleUrls: [
    './inquiry-view.component.css',
    '../../../app.component.css'
  ]
})

export class InquiryViewComponent extends ViewTableComponent implements OnInit {

  StudentDashboardWrapperComponent = StudentDashboardWrapperComponent;

  // Add property for scroll state
  isScrolled: boolean = false;
  private scrollThreshold = 50; // pixels to scroll before enhanced shadow appears

  // Autocomplete options for the combined Name filter.
  autoCompleteNameOptions: { value: string; label: string }[] = [];

  // Display functions for autocompletes that submit IDs
  displayInquiryTaker = (value: string): string => {
    const option = this.autoCompleteFirstLastNameOptions?.find((o: any) => o.value === value);
    return option ? option.label : value ?? '';
  }

  displayTeacher = (value: string): string => {
    const option = this.autocompleteInstructorOptions?.find((o: any) => o.value === value);
    return option ? option.label : value ?? '';
  }

  displayName = (value: string): string => {
    const option = this.autoCompleteNameOptions?.find((o: any) => o.value === value);
    return option ? option.label : value ?? '';
  }

  // Combined first+last name autocomplete; submits contact_id.
  onNameInput($event: { target: { value: string } }) {
    this._drupalRESTService.httpGET('/api/v1/inquiry-report/autocomplete', [
      { parameter: 'field', value: 'field_name' },
      { parameter: 'q', value: $event.target.value },
    ]).subscribe((data: any) => {
      this.autoCompleteNameOptions = data;
    });
  }

  override onViewsAutocompleteEmail($event: { target: { value: string } }) {
    this._drupalRESTService.httpGET('/api/v1/inquiry-report/autocomplete', [
      { parameter: 'field', value: 'field_email' },
      { parameter: 'q', value: $event.target.value },
    ]).subscribe((data: any) => {
      this.autoCompleteOptions = data;
    });
  }

  override displayedColumns: string[] = [
    'field_first_name',
    'field_last_name',
    'field_inquired',
    'field_booked_on',
    'field_showed',
    'inquiry_taker',
    'teacher',
    'field_email',
    'field_cell_phone',
    'field_inquiry_method',
    'field_notes',
    'actions'
  ];

  // Flag to track loading state for export
  override isLoading: boolean = false;

  constructor(
    public override _refreshService: RefreshService,
    public override _dialogService: DialogService,
    public override _entityRESTService: EntityRESTService,
    public override _utilityService: UtilityService,
    public override _fieldsService: FieldsService,
    public override _drupalRESTService: DrupalRESTService,
    public override _taxonomyService: TaxonomyService,
    public override _router: Router,
    public override _activatedRoute: ActivatedRoute,
    public override _authRESTService: AuthRESTService,
    public override _authService: AuthService,
    public override _menuRESTService: MenuRESTService,
    public override _formBuilder: FormBuilder,
    public override _routeEventsService: RouteEventsService,
    public override _permissionsService: PermissionsService,
    public override _renderer2: Renderer2,
    public override _configPages: ConfigPagesService,
    public override _packagesService: PackagesService,
    public override _snackBar: MatSnackBar,
    public override _userRESTService: UserService,
    public override _el: ElementRef,
    public override _changeDetectorRef: ChangeDetectorRef,
    public override _sanitizer: DomSanitizer,
    private dialog: MatDialog,
    public override _studioConfigService: StudioConfigService,
    public override _componentRefreshService: ComponentRefreshService,
    public override _translateService: TranslateService
  ) {
    super(
      _refreshService,
      _dialogService,
      _entityRESTService,
      _utilityService,
      _fieldsService,
      _drupalRESTService,
      _taxonomyService,
      _router,
      _activatedRoute,
      _authRESTService,
      _authService,
      _menuRESTService,
      _formBuilder,
      _routeEventsService,
      _permissionsService,
      _renderer2,
      _configPages,
      _packagesService,
      _snackBar,
      _userRESTService,
      _el,
      _changeDetectorRef,
      _sanitizer,
      _studioConfigService,
      _componentRefreshService,
      _translateService
    );
  }

  private _printService: PrintService;

  // An inquiry student account can reference multiple contacts (e.g. a couple).
  // The endpoint returns one row per account with the primary in the headline
  // and every non-retired contact in contacts[]. Stack the secondary names/
  // email/phone under the primary in their cells.
  secondaryContacts(element: any): any[] {
    const contacts = element?.contacts ?? [];
    return contacts.filter(
      (c: any) => String(c.contact_id) !== String(element?.primary_contact_id) && (c.name ?? '').trim() !== ''
    );
  }

  override ngOnInit() {
    // Initialize pagination values
    this.paginationIndex = 0;
    this.pageSize = 25;  // Default page size (matches Student List)
    this._printService = new PrintService(this._drupalRESTService, this._authService);

    // NOTE: We intentionally do NOT call super.ngOnInit() here.
    // The parent's ngOnInit subscribes to queryParams and calls getData
    // on every route change, which causes double-firing and race conditions.
    // Instead, this component manages its own data loading directly.

    // Initial data load with pagination parameters
    this.getData([
      { parameter: 'page', value: this.paginationIndex.toString() },
      { parameter: 'items_per_page', value: this.pageSize.toString() }
    ]);
  }

  /**
   * Override onSubmit to directly call getData instead of relying on the
   * fragile router-subscription chain. This ensures filters always apply.
   */
  override onSubmit(form: NgForm): void {
    LoggerService.log('InquiryViewComponent: submitting form values', form.form.value);

    // Convert date value(s) to what Drupal expects: YYYY-MM-DD
    for (const property in form.form.value) {
      if (moment.isMoment(form.form.value[property])) {
        const momentValue = form.form.value[property] as moment.Moment;
        form.form.value[property] = form.form.value[property]
          ? this.reportDateService.formatCalendarParam(momentValue.toDate())
          : '';
      }
    }

    // Build query params from non-empty form values
    this.queryParams = [];
    for (const property in form.form.value) {
      if (form.form.value[property] && form.form.value[property] !== '') {
        this.queryParams.push({ parameter: property, value: form.form.value[property] });
      }
    }

    // Reset pagination when filters change
    this.paginationIndex = 0;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }

    // Directly fetch data; don't rely on the router subscription
    this.getData([
      ...this.queryParams,
      { parameter: 'page', value: '0' },
      { parameter: 'items_per_page', value: this.pageSize.toString() }
    ]);

    // Update URL for deep-linking (fire-and-forget, don't depend on it for data)
    const routeParams: any = {};
    this.queryParams.forEach(p => routeParams[p.parameter] = p.value);
    this._router.navigate([], {
      relativeTo: this._activatedRoute,
      queryParams: { ...routeParams, page: '0' },
      queryParamsHandling: 'merge'
    });
  }

  /**
   * Refreshes the data by calling getData with current query parameters
   */
  refreshData(): void {
    LoggerService.log('InquiryViewComponent: Refreshing data');
    this.getData(this.queryParams);
  }

  downloadInquiryReport(): void {
    const paramsForDownload = (this.queryParams ?? []).map(param => ({ ...param }));
    this.downloadCSVDrupalViews('/api/v1/inquiry-report/export', 'inquiry_report', paramsForDownload);
  }

  printInquiryReport(): void {
    const rows: any[] = this.dataSource?.data ?? [];
    const reportTitle = 'Inquiry Data Report';

    const escape = (v: any) => {
      const s = v === null || v === undefined ? '' : String(v);
      return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    };
    const formatDate = (v: any) => this.reportDateService.formatDate(v);

    const headers = [
      'First Name', 'Last Name', 'Inquired', 'Booked On', 'Showed',
      'Inquiry Taker', 'Teacher', 'Email', 'Cell Phone', 'Inquiry Method', 'Notes'
    ];
    const headerHtml = headers.map(h => `<th>${escape(h)}</th>`).join('');

    const bodyHtml = rows.map((r: any) => {
      // Stack every named contact so a couple reads naturally in one row.
      const contacts = (r.contacts ?? []).filter((c: any) => (c.name ?? '').trim() !== '');
      const firstNames = contacts.map((c: any) => c.first_name).filter((x: string) => (x ?? '').trim());
      const lastNames = contacts.map((c: any) => c.last_name).filter((x: string) => (x ?? '').trim());
      const emails = contacts.map((c: any) => c.email).filter((x: string) => (x ?? '').trim());
      const phones = contacts.map((c: any) => c.phone).filter((x: string) => (x ?? '').trim());
      const firstCell = firstNames.length ? firstNames.map(escape).join('<br>') : escape(r.field_first_name);
      const lastCell = lastNames.length ? lastNames.map(escape).join('<br>') : escape(r.field_last_name);
      const emailCell = emails.length ? emails.map(escape).join('<br>') : escape(r.field_email);
      const phoneCell = phones.length ? phones.map(escape).join('<br>') : escape(r.field_cell_phone);
      return `<tr>
        <td>${firstCell}</td>
        <td>${lastCell}</td>
        <td class="nowrap">${escape(formatDate(r.field_inquired))}</td>
        <td class="nowrap">${escape(formatDate(r.field_booked_on))}</td>
        <td class="nowrap">${escape(formatDate(r.field_showed))}</td>
        <td>${escape(r.inquiry_taker)}</td>
        <td>${escape(r.teacher)}</td>
        <td>${emailCell}</td>
        <td class="nowrap">${phoneCell}</td>
        <td>${escape(r.field_inquiry_method)}</td>
        <td>${escape(r.field_notes)}</td>
      </tr>`;
    }).join('');

    const countHtml = `<div class="row-count">${rows.length} inquiry account${rows.length === 1 ? '' : 's'}</div>`;

    const content = `
      <h1 class="report-title">${escape(reportTitle)}</h1>
      ${countHtml}
      <table class="report-table">
        <thead><tr>${headerHtml}</tr></thead>
        <tbody>${bodyHtml}</tbody>
      </table>
    `;

    const styles = `
      @page { size: letter landscape; margin: 0.5in; }
      .report-table { width: 100%; border-collapse: collapse; font-size: 9px; }
      .report-table th, .report-table td { border: 1px solid #ccc; padding: 3px 5px; vertical-align: top; }
      .report-table th { background: #f0f0f0; }
      .report-table td.nowrap { white-space: nowrap; }
      .row-count { margin: 4px 0 8px 0; font-size: 11px; color: #555; }
    `;

    this._printService.print(content, {
      title: reportTitle,
      styles,
      showSchoolName: true,
      promptPrint: true
    });
  }

  override getData(params: { parameter: string; value: string; }[]) {
    this.ShowProgressBar = true;

    // Store only non-pagination params in queryParams
    this.queryParams = params.filter(param =>
      param.parameter !== 'page' && param.parameter !== 'items_per_page'
    );

    // Add current pagination state to params if not present
    let finalParams = [...params];
    if (!params.some(p => p.parameter === 'page')) {
      finalParams.push(
        { parameter: 'page', value: this.paginationIndex.toString() },
        { parameter: 'items_per_page', value: this.pageSize.toString() }
      );
    }

    // Add sorting parameters if available. sortParams is an object
    // ({sort_by, sort_order}) from sortDataView, so flatten into entries.
    if (this.sortParams !== undefined && this.sortParams !== null) {
      if (Array.isArray(this.sortParams)) {
        finalParams.push(...this.sortParams);
      } else if (typeof this.sortParams === 'object') {
        for (const key in this.sortParams) {
          if (this.sortParams[key] !== undefined && this.sortParams[key] !== '') {
            finalParams.push({ parameter: key, value: this.sortParams[key] });
          }
        }
      }
    }

    this._drupalRESTService.httpGET('/api/v1/inquiry-report', finalParams)
      .subscribe((data) => {
        this.ShowProgressBar = false;
        this.data = data;
        this.dataSource = new MatTableDataSource(data['results']);

        // Update pagination using the parent class method
        if (data['results']) {
          this.setupPagination(data, params);
        }
      },
      error => this.handleError(error)
    );
  }

  // When resetForm is clearing state it also resets the sort header, which
  // re-enters sortDataView. Skip the redundant fetch in that case.
  private isResetting = false;

  /**
   * Override sortDataView to directly re-fetch data. The parent relies on a
   * router subscription to reload on sort change, but this component bypasses
   * that subscription (see ngOnInit comment), so we reload explicitly here.
   */
  override sortDataView(sort: Sort): void {
    super.sortDataView(sort);

    if (this.isResetting) {
      return;
    }

    this.paginationIndex = 0;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }

    this.getData([
      ...this.queryParams,
      { parameter: 'page', value: '0' },
      { parameter: 'items_per_page', value: this.pageSize.toString() }
    ]);
  }

  override resetForm() {
    // Clear all stored params
    this.queryParams = [];
    this.sortParams = undefined;

    // Reset the MatSort UI state so the column arrow clears too.
    // Guard sortDataView so it doesn't fire a redundant getData here.
    if (this.sort) {
      this.isResetting = true;
      this.sort.sort({ id: '', start: 'asc', disableClear: false });
      this.isResetting = false;
    }

    // Reset pagination
    if (this.paginator) {
      this.paginator.pageIndex = 0;
      this.paginationIndex = 0;  // Reset the pagination index
      this.pageSize = 25;  // Reset page size (matches Student List default)
    }

    // Clear the form
    this.form.resetForm();

    // Clear any autocomplete options
    this.autoCompleteNameOptions = [];

    // Make a fresh request with explicitly empty params
    this.getData([
      { parameter: 'page', value: '0' },
      { parameter: 'items_per_page', value: '25' }
    ]);

    // Update router last
    this.updateRouterParams({});
  }

  override pageChanged(event: PageEvent) {
    // Update pagination state
    this.paginationIndex = event.pageIndex;
    this.pageSize = event.pageSize;

    // Always include pagination parameters
    const paginationParams: HttpParameter[] = [
      { parameter: 'page', value: this.paginationIndex.toString() },
      { parameter: 'items_per_page', value: this.pageSize.toString() }
    ];

    // Filter out any existing pagination params from queryParams
    const filteredQueryParams = this.queryParams.filter(param =>
      param.parameter !== 'page' && param.parameter !== 'items_per_page'
    );

    // Combine filtered query params with new pagination params
    const combinedParams = [...filteredQueryParams, ...paginationParams];
    this.getData(combinedParams);
  }

  override onPageSizeOptions() {
    return [10, 25, 50];
  }

  /**
   * Opens the dialog to book a student from an inquiry
   * @param inquiry The inquiry data object
   */
  openBookDialog(inquiry: any): void {
    LoggerService.log('Opening book dialog with inquiry data:', inquiry);

    const dialogRef = this.dialog.open(BookFromInquiryReportComponent, {
      width: '800px',
      maxWidth: '95vw',
      // The app-wide default is a fixed 500px tall; this dialog sizes to content.
      height: 'auto',
      panelClass: 'fit-content-dialog',
      data: {
        inquiryId: inquiry.nid,
        studentName: `${inquiry.field_first_name} ${inquiry.field_last_name}`,
        inquiryDate: inquiry.field_inquired,
        studentId: inquiry.student_account_id,
        contactId: inquiry.contact_id
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Handle successful booking
        this.refreshData();
      }
    });
  }

  // Add scroll listener
  @HostListener('window:scroll', ['$event'])
  onScroll(event: any) {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    this.isScrolled = scrollPosition > this.scrollThreshold;
  }

  override setupPagination(data: any, params: { parameter: string; value: string; }[]) {
    const pageParam = params.find(param => param.parameter === 'page');
    if (this.paginator) {
      this.paginator.length = data?.['count'] ?? 0;
      this.paginator.pageSize = this.pageSize;
      this.paginator.pageIndex = pageParam ? parseInt(pageParam.value, 10) : 0;
    }
    // DO NOT call updateRouterParams here - prevents duplicate requests
  }
}
